module.exports = __webpack_public_path__ + "img/HIDE.6789fbcd.svg";